<fieldset>
    <div class="card-blue light md bordered" style="height: 100%;margin: 5px" [style]="cardStyle">
        <ng-content select="[header]"></ng-content>
        <p-scrollPanel styleClass="search-in-card" [dir]="dir" [style]="{width: '100%', height: contentHeight}">
            <ng-content select="[content]"></ng-content>
        </p-scrollPanel>
    </div>
</fieldset>